function getFormattedDecimalVal(stringVal) {
  const val = stringVal.substr(0, 2);
  return val.length < 2 ? `${val}0` : val;
}

export function formattedPriceString(value, countryProps) {
  if (!value) {
    return '';
  }

  const values = `${value}`.split('.');
  const integerString = values[0].split('').reduce((prev, next, index, array) => {
    return (array.length - index) % 3 !== 0 || index === 0
      ? `${prev}${next}`
      : `${prev}${countryProps.thousandsDelim}${next}`;
  }, '');
  const decimalVal = values.length > 1 ? getFormattedDecimalVal(values[1]) : '';
  let stringValue = decimalVal !== '' ? `${integerString}${countryProps.decimalChar}${decimalVal}` : integerString;
  stringValue =
    countryProps.currencyPlacement === 'after'
      ? `${stringValue} ${countryProps.currency}`
      : `${countryProps.currency} ${stringValue}`;
  return stringValue;
}
